import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isAuthenticated: false,
  patient: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true
      state.patient = action.payload
    },
    logout: (state) => {
      state.isAuthenticated = false
      state.patient = null
    },
    updatePatient: (state, action) => {
      state.patient = action.payload
    },
  },
})

export const { login, logout, updatePatient } = authSlice.actions
export default authSlice.reducer
